module.exports = __webpack_public_path__ + "img/daichao1.1fa5f54e.png";